import { render, staticRenderFns } from "./AttributeDefaultValue.vue?vue&type=template&id=34414248&scoped=true&"
import script from "./AttributeDefaultValue.vue?vue&type=script&lang=js&"
export * from "./AttributeDefaultValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34414248",
  null
  
)

export default component.exports